import { loginChannel, reserve } from '@/api/system.api.js'

import dialogFormMixins from '@/mixins/dialogFormMixins.js'

import { getSign, isIOS } from '@/utils/common.js'

import { mapActions, mapMutations } from 'vuex'

const defaultForm = {
  os: '',
  phone: '',
  captcha: '',
  captcha_id: '',
  code: '',
  invite_code: '',
}

export default {
  mixins: [dialogFormMixins],
  // props: {
  //   visible: {
  //     type: Boolean,
  //     default: false,
  //   }
  // },
  data() {
    return {
      dialogVisible: false,
      form: JSON.parse(JSON.stringify(defaultForm)),
      tips: '',
      osID: [],
      verifyCodeToken: '',
      needVerifyCode: '',
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    },
    user() {
      return this.$store.getters.user
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
    isReserved() {
      return this.$store.getters.isReserved
    },
    query() {
      return this.$route.query
    },
    inviteCode() {
      return this.query.inviteCode
    },
    visible() {
      return this.$store.getters.loginDialogVisible
    },
  },
  watch: {
    visible: async function (val) {
      this.dialogVisible = val

      if (val) {
        await this.getLoginChannel()
        
        if (this.needVerifyCode) this.getCaptchaInfo()

        if (this.inviteCode) this.form.invite_code = this.inviteCode
      }
    }
  },
  methods: {
    ...mapActions(['doLogin', 'handleLoginSuccess']),
    ...mapMutations(['setTipsDialog', 'setIsReserved', 'setLoginDialog']),
    close() {
      this.setLoginDialog({ visible: false })
    },
    async getLoginChannel() {
      this.osID = []

      const params = {
        game: 'tc',
        time: Date.parse(new Date()) / 1000,
      }
      params.sign = getSign(params)
      await loginChannel(params)
        .then((res) => {
          if (res.code != 0) {
            this.setTipsDialog({ visible: true, tips: res.msg })
            return false
          }

          const data = res.data
          if (data.android) this.osID.android = data.android
          if (data.ios) this.osID.ios = data.ios

          this.verifyCodeToken = data.token
          this.needVerifyCode = data.verifyCode
        })
    },
    async handleReserve() {
      this.checkForm()
      // 弹出提示窗
      if (this.tips != '') {
        this.setTipsDialog({ visible: true, tips: this.tips }) // 展示提示窗口
        return false
      }

      // 防止当前阶段还未加载出来时触发预约
      if (this.stage !== 0 && this.stage !== 1) {
        this.tips = '请刷新页面后重试~'
        this.setTipsDialog({ visible: true, tips: this.tips })
        return false
      }

      let loginRes = {}
      if (!this.isLogin) {
        loginRes = await this.doLogin({
          form: this.form,
          osID: this.osID,
        })
        if (Object.keys(loginRes).length == 0) return false
      }
      
      let reserveRes = true
      
      if ((this.stage === 0 && !this.isReserved) || (this.stage === 1 && this.form.invite_code)) {
        let type
        if (this.stage == 0) type = 2
        if (this.stage == 1) type = 3
        const postData = {
          token: loginRes.token,
          inviteCode: this.form.invite_code,
          type: type, // 根据阶段类型判断是邀请预约还是邀请下载
        }
        postData.sign = getSign(postData)
        reserveRes = await reserve(postData)
          .then((res) => {
            let falg = true
            if (res.code != 0) {
              this.tips = res.msg
              falg = false
            } else {
              this.setIsReserved(1)
              this.tips = '登录成功'

              // IOS预约成功后跳转到app store
              if (isIOS()) {
                // 由于safari安全策略会阻止回调函数执行window.open，此处使用此方式唤起
                window.location.href = 'https://apps.apple.com/cn/app/id6471931091'
              }
            }
  
            this.setTipsDialog({ visible: true, tips: this.tips }) // 展示提示窗口 

            return falg
          })
      } else {
        this.setTipsDialog({ visible: true, tips: '登录成功' }) // 展示提示窗口
      }

      if (!reserveRes) return false

      this.handleLoginSuccess({ data: loginRes })
      
      this.close() // 关闭预约窗口
        
      const query = JSON.parse(JSON.stringify(this.query))
      if (query.inviteCode) {
        this.$delete(query, 'inviteCode')

        this.$router.replace({ query })
      }

      // 重置表单
      this.form = JSON.parse(JSON.stringify(defaultForm))

      // 触发登录成功事件
      this.$emit('success')
    },
    // 校验表单
    checkForm() {
      this.tips = ''
      if (this.form.os !== 0 && this.form.os !== 1) {
        this.tips = '请选择平台'
        return
      }
      // 未登录时需要校验的字段
      if (!this.isLogin) {
        if (this.form.phone == '') {
          this.tips = '请输入手机号'
          return
        }
        if (this.needVerifyCode && (this.form.captcha == '' || this.form.captcha_id == '')) {
          this.tips = '请输入图形验证码'
          return
        }
        if (this.form.code == '') {
          this.tips = '请输入手机验证码'
          return
        }
      }
    },
  }
}